import React from "react";
import { Checkbox, Form, Input, Tag } from "antd";
import CustomUpload from "../../../../components/Upload";
import IntlImageUpload from "./IntlImageUpload";
import styles from "../index.modules.less";

const LanguageTabPanel = ({
  form,
  languageCode,
  languageLabel,
  isDefault,
  onSetDefault,
  nameDisabled = false,
}) => {
  const nameLabel = `${languageLabel}名称`;
  const logoLabel = `${languageLabel} Logo`;
  const snapshotLabel = `${languageLabel}界面截图`;
  const introLabel = `${languageLabel}介绍`;

  const nameField = isDefault ? (
    <Form.Item
      name="app_name"
      label={nameLabel}
      rules={[{ required: true, message: `请填写${languageLabel}的软件名称` }]}
    >
      <Input
        disabled={nameDisabled}
        placeholder={`请输入该软件在【${languageLabel}】环境下的显示名称`}
        className="appinfo-input"
      />
    </Form.Item>
  ) : (
    <Form.Item
      name={["extendedLang", languageCode, "soft_name"]}
      label={nameLabel}
      rules={[{ required: true, message: `请填写${languageLabel}的软件名称` }]}
    >
      <Input
        disabled={nameDisabled}
        placeholder={`请输入该软件在【${languageLabel}】环境下的显示名称`}
        className="appinfo-input"
      />
    </Form.Item>
  );

  const logoField = isDefault ? (
    <Form.Item
      name="logo_pic"
      label={logoLabel}
      htmlFor={undefined}
      valuePropName="fileList"
      getValueFromEvent={(event) => event}
      rules={[{ required: true, message: "请上传 Logo" }]}
    >
      <CustomUpload
        accept=".jpg, .jpeg, .png"
        tips="72×72px，不超过 2M，格式 jpg/jpeg/png"
        maxCount={1}
        name="logo_pic"
        form={form}
        width={72}
        height={72}
        size={2}
      />
    </Form.Item>
  ) : (
    <Form.Item
      name={["extendedLang", languageCode, "soft_logo"]}
      label={logoLabel}
      htmlFor={undefined}
      valuePropName="fileList"
      getValueFromEvent={(event) => event}
      rules={[{ required: true, message: "请上传 Logo" }]}
    >
      <IntlImageUpload
        fieldPath={["extendedLang", languageCode, "soft_logo"]}
        accept=".jpg, .jpeg, .png"
        tips="72×72px，不超过 2M，格式 jpg/jpeg/png"
        maxCount={1}
        form={form}
        width={72}
        height={72}
        size={2}
      />
    </Form.Item>
  );

  const snapshotField = isDefault ? (
    <Form.Item
      name="running_pic"
      label={snapshotLabel}
      htmlFor={undefined}
      valuePropName="fileList"
      getValueFromEvent={(event) => event}
      rules={[{ required: true, message: "请上传界面截图" }]}
    >
      <CustomUpload
        form={form}
        name="running_pic"
        tips="1000×666px，不超过 5M，格式 jpg/jpeg/png，最多 5 张"
        maxCount={5}
        accept=".jpg, .jpeg, .png"
        width={1000}
        height={666}
        size={5}
      />
    </Form.Item>
  ) : (
    <Form.Item
      name={["extendedLang", languageCode, "soft_snapshot"]}
      label={snapshotLabel}
      htmlFor={undefined}
      valuePropName="fileList"
      getValueFromEvent={(event) => event}
      rules={[{ required: true, message: "请上传界面截图" }]}
    >
      <IntlImageUpload
        fieldPath={["extendedLang", languageCode, "soft_snapshot"]}
        tips="1000×666px，不超过 5M，格式 jpg/jpeg/png，最多 5 张"
        maxCount={5}
        accept=".jpg, .jpeg, .png"
        form={form}
        width={1000}
        height={666}
        size={5}
      />
    </Form.Item>
  );

  const introField = isDefault ? (
    <Form.Item
      name="feature"
      label={introLabel}
      rules={[{ required: true, message: "请填写软件介绍" }]}
    >
      <Input.TextArea
        className="appinfo-feature"
        showCount
        placeholder={`请使用【${languageLabel}】填写详细的软件介绍，不超过 1000 字`}
        maxLength={1000}
      />
    </Form.Item>
  ) : (
    <Form.Item
      name={["extendedLang", languageCode, "soft_description"]}
      label={introLabel}
      rules={[{ required: true, message: "请填写软件介绍" }]}
    >
      <Input.TextArea
        className="appinfo-feature"
        showCount
        placeholder={`请使用【${languageLabel}】填写详细的软件介绍，不超过 1000 字`}
        maxLength={1000}
      />
    </Form.Item>
  );

  return (
    <div className={styles.multiLangPanel}>
      {nameField}

      <Form.Item label="默认语言" className={styles.defaultLangRow}>
        <Checkbox
          checked={isDefault}
          disabled={isDefault}
          onChange={() => {
            if (!isDefault) {
              onSetDefault(languageCode);
            }
          }}
        >
          设为默认语言
        </Checkbox>
        {isDefault ? (
          <Tag color="blue" className={styles.currentDefaultTag}>
            当前默认
          </Tag>
        ) : null}
        <span className={styles.defaultLangHint}>
          （无匹配语言时对用户的兜底展示）
        </span>
      </Form.Item>

      {logoField}
      {snapshotField}
      {introField}
    </div>
  );
};

export default LanguageTabPanel;
